module.exports = __webpack_public_path__ + "static/media/weikang3.fdaef971.png";